import React, { Component } from 'react';
import { Cell, Grid, SelectField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import QuizListWidget from '../component/QuizListWidget';
import SecureShow from '../component/SecureShow';
import '../css/Dashboard.css';
import {getReportBlobData, getReportBlobDataNonGraded, getReportBlobTestData, GeneratingReportLoader, getMQTReportBlobData} from '../pages/CoursesDashboard'
import { saveAs } from 'file-saver';
import JsZip from 'jszip';
import { AppProperties } from '../common/function';





export default class ViewScoreArchives extends Component{

    appProperties = AppProperties();
    baseFolder = this.appProperties.baseFolder;

    constructor(props){
        super(props);

        this.state = {
            archiveInProgress:false,
            loadingArchivedList:false,
            loadingCourse:true,
            showSection:false,
            showDashBoard:false,
            loadingQuizesData:false,
            archivedSemester:[],
            selectedSemesterID:undefined,
            selectedSectionID:undefined,
            courses:[],
            sectionMap:{},
            archivedQuizes:[],
            downloadListArray: [{title:"Download All Graded",id:0},{title:"Download All Non-Graded", id:1},{title:"Download All Graded & Non-Graded", id:1}],
            generatingQuizReports:false,
            reportGenerationProgress:0,
            reportGenerationStatus:[],
        };
    }

    componentWillMount(){
        this.getArchivedSemesters();
    }

    getArchivedSemesters = async() =>{
        this.setState({loadingArchivedList:true});
        try{
            let getArchivedSemestersResponse = await ApiRequestService({
                method: 'post',
                url:'getArchivedSemesters',
                data: ''
            })
            if(getArchivedSemestersResponse.data !== undefined && getArchivedSemestersResponse.data !== null){
                if(getArchivedSemestersResponse.data.status === 0 && getArchivedSemestersResponse.data.data !== undefined && getArchivedSemestersResponse.data.data !== null){
                    this.setState({'archivedSemester':getArchivedSemestersResponse.data.data });
                }else if (getArchivedSemestersResponse.data.message !== undefined &&  getArchivedSemestersResponse.data.message !== null ) {
                    NotificationManager.error(getArchivedSemestersResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }catch(err){

            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingArchivedList:false});
        }
    }

    getArchivedQuizes = async(sectionID) => {
        this.setState({loadingQuizesData:true});
        try{
            let getArchivedQuizesResponse = await ApiRequestService({
                method: 'post',
                url:'getArchivedQuizes',
                data: {
                    semesterID:this.state.selectedSemesterID,
                    courseID:this.state.selectedCourseID,
                    sectionID:sectionID
                }
            })
            if(getArchivedQuizesResponse.data !== undefined && getArchivedQuizesResponse.data !== null){
                if(getArchivedQuizesResponse.data.status === 0 && getArchivedQuizesResponse.data.data !== undefined && getArchivedQuizesResponse.data.data !== null){
                    console.log("getArchivedQuizesResponse",getArchivedQuizesResponse.data.data);
                    this.setState({archivedQuizes:getArchivedQuizesResponse.data.data})

                }else if (getArchivedQuizesResponse.data.message !== undefined &&  getArchivedQuizesResponse.data.message !== null ) {
                    NotificationManager.error(getArchivedQuizesResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }catch(err){

            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({showDashBoard:true});
        }
    }

    onSemesterSelected = (value, index, event, details) =>{
        this.getArchivedCoursesAndSections(value);
        this.setState({selectedSemesterID:value});
    }

    onCourseSelected =  (value, index, event, details) =>{
        this.setState({selectedCourseID:value,showSection:true,showDashBoard:false,selectedSectionID:undefined});
    }

    onSectionSelected = (value, index, event, details) =>{
        this.setState({selectedSectionID:value});
        this.getArchivedQuizes(value);

    }

    tabOnChange = (e) => {
        console.debug('tab name = ', e);
        if (e === 'Category') {
          this.setState({
            categoryDiv: true,
            questionsDiv: false,
            explanationDiv: false,
            mode: 1
          });
        } else if (e === 'Explanation') {
          this.setState({
            categoryDiv: false,
            questionsDiv: false,
            explanationDiv: true,
            mode: 2
          });
        }
    }

    onViewScoreClicked = (quizData) => {
        console.log('quizData1',quizData);
        if(quizData && quizData.quiz_id )
            if(quizData.quiz_type === 0)
                browserHistory.push(this.baseFolder+'quizScore?archiveMode=1&semesterID='+this.state.selectedSemesterID+
                '&courseID='+this.state.selectedCourseID+
                '&sectionID='+this.state.selectedSectionID+
                '&quizID='+quizData.quiz_id+
                '&qname='+quizData.quiz_name+
                '&course_name='+quizData.course_name);
            else
                browserHistory.push(this.baseFolder+'testScore?archiveMode=1&semesterID='+this.state.selectedSemesterID+
                '&courseID='+this.state.selectedCourseID+
                '&sectionID='+this.state.selectedSectionID+
                '&quizID='+quizData.quiz_id+
                '&qname='+quizData.quiz_name+
                '&course_name='+quizData.course_name);

    }



    getArchivedCoursesAndSections = async(selectedSemesterID) => {
        this.setState({loadingCourse:true,showSection:false,showDashBoard:false});
        try{
            let getArchivedCourses = await ApiRequestService({
                method: 'post',
                url:'getArchivedCourses',
                data: selectedSemesterID
            })
            if(getArchivedCourses.data !== undefined && getArchivedCourses.data !== null){
                if(getArchivedCourses.data.status === 0 && getArchivedCourses.data.data !== undefined && getArchivedCourses.data.data !== null){
                    if(getArchivedCourses.data.data.courses !== undefined && getArchivedCourses.data.data.courses !== null){
                        this.setState({courses:getArchivedCourses.data.data.courses});
                    }else{
                        NotificationManager.error("No Courses Found for Semester","Error",5000);
                    }
                    if(getArchivedCourses.data.data.sectionMap !== undefined && getArchivedCourses.data.data.sectionMap !== null){
                        this.setState({sectionMap:getArchivedCourses.data.data.sectionMap});
                    }else{
                        NotificationManager.error("No Sections Found for Semester","Error",5000);
                    }

                }else if (getArchivedCourses.data.message !== undefined &&  getArchivedCourses.data.message !== null ) {
                    NotificationManager.error(getArchivedCourses.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }catch(err){

            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingCourse:false});
        }
    }

    generateConsolidatedReport = async(quizes,courseName,dropIndex)=>{
        const totalQuizes = quizes.length;
        let completedQuizes = 0;
        let DropIndex = dropIndex;

        let isOrg = window.location.hostname.includes("org");
        console.debug("appProperties.appURL", this.appProperties.appURL)
    
        let appURL = this.appProperties.appURL;
    
        if (isOrg) {
          appURL = appURL.replace(".com", ".org")
        }
        console.debug("appURL ----", appURL);
    
        return new Promise(async (resolve,reject)=>{
          let jsZip = JsZip();
          //loop through quizes
          if(quizes && quizes.length>0){
            
            for (let index = 0; index < quizes.length; index++) {
              const quiz = quizes[index];
              
              try{
                let reportBlobData;
                if(quiz.quiz_type == 0){
    
                      let reportLink = `${appURL}quizScore?archiveMode=1&semesterID=${quiz.semester_id}&courseID=${quiz.course_id}&sectionID=${quiz.section_Id}&quizID=${quiz.quiz_id}&qname=${quiz.quiz_name}&course_name=${quiz.course_name}`;
                      
                      if(DropIndex == 0){
                        reportBlobData = await getReportBlobData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                        jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Graded.csv`, reportBlobData, {binary:true});
                      }else if(DropIndex == 1){
                        let reportMRBlobData = await getReportBlobDataNonGraded(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                        reportBlobData = reportMRBlobData.data
                        if(reportBlobData !== "No Data"){
                        jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Non-Graded.csv`, reportBlobData, {binary:true});
                        }
                        if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                            try {
                                await getMQTReportBlobData(reportLink, `${quiz.quiz_id}_${quiz.section_Id}`, jsZip, quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_'), quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-'));
                                reportBlobData = "Data Present";
                            } catch(err) {
                            console.log("Error", err);
                            }      
                        }
                      }else if(DropIndex == 2){
                        let reportMRBlobData = await getReportBlobDataNonGraded(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                        reportBlobData = reportMRBlobData.data
                        if(reportBlobData !== "No Data"){
                        jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Non-Graded.csv`, reportBlobData, {binary:true});
                        }
                        if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                            try {
                                await getMQTReportBlobData(reportLink, `${quiz.quiz_id}_${quiz.section_Id}`, jsZip, quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_'), quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-'));
                            } catch(err) {
                            console.log("Error", err);
                            }      
                        }
                        reportBlobData = await getReportBlobData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                        jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Graded.csv`, reportBlobData, {binary:true});
                        if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                            reportBlobData = "Data Present"
                          }
                    }
    
                }else{
                      let reportLink = `${appURL}testScore?archiveMode=1&semesterID=${quiz.semester_id}&courseID=${quiz.course_id}&sectionID=${quiz.section_Id}&quizID=${quiz.quiz_id}&qname=${quiz.quiz_name}&course_name=${quiz.course_name}`;
                      reportBlobData = await getReportBlobTestData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                      jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Test-Data.csv`, reportBlobData, {binary:true});
                }
    
                completedQuizes++;
                let status = 1
                
                if(reportBlobData === "No Data"){
                  status = -1
                }
                
                
                let copy = [...this.state.reportGenerationStatus]
                copy.splice(index, 1, {quizName:copy[index].quizName,status:status})
                this.setState({
                  reportGenerationProgress:((completedQuizes/totalQuizes)*100),
                  reportGenerationStatus:[...copy]
                });
              }catch(err){
                console.log("Error",err);
              }      
            }
            
            if(DropIndex == 0){
              jsZip.generateAsync({type: "blob"}).then(zipFile=>{
                saveAs(zipFile, `${courseName}_conslidated_graded.zip`)
              }).finally(()=>{
                resolve(true);
              });
            }else if(DropIndex == 1){
              jsZip.generateAsync({type: "blob"}).then(zipFile=>{
                saveAs(zipFile, `${courseName}_conslidated_non-graded.zip`)
              }).finally(()=>{
                resolve(true);
              });
            }else if(DropIndex == 2){
              jsZip.generateAsync({type: "blob"}).then(zipFile=>{
                saveAs(zipFile, `${courseName}_conslidated_graded_&_non-graded.zip`)
              }).finally(()=>{
                resolve(true);
              });
            }
          }else{
            //TODO show Error Message
            resolve(true);
          }
        });
        
      }


   createConsolidatedReport=(_,index)=>{
     this.setState({generatingQuizReports:true,reportGenerationProgress:0,reportGenerationStatus:[]});
   if(this.state.selectedCourseID && this.state.selectedSemesterID){
      this.setState({reportGenerationStatus:this.state.archivedQuizes.map(quiz=>{return {quizName:`SECTION - ${quiz.section_name} and QUIZ - ${quiz.quiz_name}`,status:0}})})
      let selectedCourseDetails = this.state.courses.filter((course) => { if(course.value === this.state.selectedCourseID){return course.label}})
      console.log("Course Name", selectedCourseDetails[0].label)
      console.log("Course Name1", this.state.archivedQuizes)
      this.generateConsolidatedReport([...this.state.archivedQuizes],selectedCourseDetails[0].label,index).finally(()=>{
          this.setState({generatingQuizReports:false});
         }) 
     }
    
    }



    render(){
        if (this.state.generatingQuizReports){
            return <GeneratingReportLoader value={this.state.reportGenerationProgress} status={this.state.reportGenerationStatus}/>
          }
        if(this.state.loadingArchivedList)
            return <LoadingSpinner/>
        return  <SecureShow targetRole={1} >
                    <Grid gutter={1} className="gradeBookPageContainer">
                        <Cell size={3}>
                            <label htmlFor="archivedSemestedDropDown">
                             {this.appProperties.schoolMode?"Select an Archived Academic Year":"Select an Archived Semester"} </label>
                            <SelectField
                                id='archivedSemestedDropDown'
                                placeholder={this.appProperties.schoolMode?"Select Standard":"Select Semester"}
                                menuItems={this.state.archivedSemester}
                                onChange={this.onSemesterSelected}
                                className="gradebook-dropdown"
                                value={this.state.selectedSemesterID}
                                />
                        </Cell>
                        {!this.state.loadingCourse?
                        <Cell size={3}>
                            <label htmlFor="archivedCourses">
                            {this.appProperties.schoolMode?"Select an Archived Standard":"Select an Archived Course"}</label>
                            <SelectField
                                id='archivedCourses'
                                placeholder={this.appProperties.schoolMode?"Select Standard":"Select Course"}
                                menuItems={this.state.courses}
                                onChange={this.onCourseSelected}
                                className="gradebook-dropdown"
                                value={this.state.selectedCourseID}
                                />
                        </Cell>:null}
                        {this.state.showSection?
                        <Cell size={3}>
                            <label htmlFor="archivedSections">Select an Archived Section </label>
                            <SelectField
                                id='archivedSections'
                                placeholder="Select Section"
                                menuItems={this.state.sectionMap[this.state.selectedCourseID]}
                                onChange={this.onSectionSelected}
                                className="gradebook-dropdown"
                                value={this.state.selectedSectionID}
                                />
                        </Cell>:null}
                        <br/><br/><br/>
                        {this.state.showDashBoard ? <SelectField
                        id="selectCourses"
                        className="DashBoardSelectFieldClass2"
                        placeholder="DOWNLOAD ALL RAW DATA"
                        itemLabel="title"
                        menuItems={this.state.downloadListArray}
                        onChange={this.createConsolidatedReport}
                        />: null} 
                        <ArchiveDashBoard key="archiveDashBoard" tabOnChange={this.tabOnChange} hide={!this.state.showDashBoard} 
                            data={this.state.archivedQuizes} onViewScoreClicked={this.onViewScoreClicked}
                            section_id={this.state.selectedSectionID}
                            course_id={this.state.selectedCourseID}/>
                    </Grid>
                </SecureShow>
    }
}

const ArchiveDashBoard = (props) => {
    if(props.hide || props.data === undefined)
        return null;
    return <Cell size={12}>
                <QuizListWidget archiveMode data={props.data} defaultRowsPerPage={10} 
                    section_id={props.section_id}
                    course_id={props.course_id}
                    onClick={props.onViewScoreClicked}/>
            </Cell>
}
